import { HubFeature } from '@ats/api/cm';
import { LocDefs, MapLocKeys } from '@cm/core/localization';

const dpRoot = 'Tools|CE Fee Vouchers';
type SPVoucherFeeBatchesLocs =
	| 'SPVoucherFeeBatchesTitle'
	| 'SPVoucherFeeBatchesBatchId'
	| 'SPVoucherFeeBatchesCrcatName'
	| 'SPVoucherFeeBatchesCreatedDate'
	| 'SPVoucherFeeBatchesExpireDate'
	| 'SPVoucherFeeBatchesRedeemedCount'
	| 'SPVoucherFeeBatchesRevokedCount'
	| 'SPVoucherFeeBatchesTotalCount'
	| 'SPVoucherFeeBatchesVoucherId'
	| 'SPVoucherFeeBatchesRedeemedBy'
	| 'SPVoucherFeeBatchesRedeemedDate'
	| 'SPVoucherFeeBatchesStatus'
	| 'SPVoucherFeeBatchesTokenSearchButton'
	| 'SPVoucherFeeBatchesChangeExpirationButton'
	| 'SPVoucherFeeBatchesInvalidateButton'
	| 'SPVoucherFeeBatchesDownloadButton'
	| 'SPVoucherFeeBatchesChangeExpirationTitle'
	| 'SPVoucherFeeBatchesChangeExpirationLabelRemoveExpirationDate'
	| 'SPVoucherFeeBatchesChangeExpirationLabelExpirationDate'
	| 'SPVoucherFeeBatchesChangeExpirationCancelButton'
	| 'SPVoucherFeeBatchesChangeExpirationConfirmButton'
	| 'SPVoucherFeeBatchesChangeExpirationSuccess'
	| 'SPVoucherFeeBatchesChangeExpirationError'
	| 'SPVoucherFeeBatchesChangeExpirationErrorExpirationDateRequired'
	| 'SPVoucherFeeBatchesInvalidateSuccess'
	| 'SPVoucherFeeBatchesInvalidateError'
	| 'SPVoucherFeeBatchesInvalidateTitle'
	| 'SPVoucherFeeBatchesInvalidateDescription'
	| 'SPVoucherFeeBatchesInvalidateConfirmButton'
	| 'SPVoucherFeeBatchesInvalidateCancelButton'
	| '0832f1f53d1f49aa8e6b8aa2caebf79e'
	| '8e8b43e31a424c1685b514d14de96241'
	| 'b21d04e578464148994c8398a0d20302'
	| '39d9015e45bb46a79d83701f82fafac7'
	| 'd58dabc2009e4105964ded449795dc42'
	| '6ea279e24b644540a1c9042adc5f03f7';

export const spVoucherFeeBatchesLocDefs: LocDefs<SPVoucherFeeBatchesLocs> = {
	SPVoucherFeeBatchesTitle: {
		defaultValue: 'Existing Fee Voucher Batches',
		description: 'Title for the existing fee voucher batches section.',
		displayPath: `${dpRoot}|Title`,
		displayType: 'Title',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'SP',
	},
	SPVoucherFeeBatchesBatchId: {
		defaultValue: 'Batch ID',
		description: 'Label for the batch ID input field.',
		displayPath: `${dpRoot}|Batch ID`,
		displayType: 'Label',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'SP',
	},
	SPVoucherFeeBatchesCrcatName: {
		defaultValue: 'Requirement Name',
		description: 'Label for the cert requirement catalog name input field.',
		displayPath: `${dpRoot}|Cert Requirement Name`,
		displayType: 'Label',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'SP',
	},
	SPVoucherFeeBatchesCreatedDate: {
		defaultValue: 'Created Date',
		description: 'Label for the created date input field.',
		displayPath: `${dpRoot}|Created Date`,
		displayType: 'Label',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'SP',
	},
	SPVoucherFeeBatchesExpireDate: {
		defaultValue: 'Expire Date',
		description: 'Label for the expire date input field.',
		displayPath: `${dpRoot}|Expire Date`,
		displayType: 'Label',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'SP',
	},
	SPVoucherFeeBatchesRedeemedCount: {
		defaultValue: 'Redeemed',
		description: 'Label for the redeemed count input field.',
		displayPath: `${dpRoot}|Redeemed Count`,
		displayType: 'Label',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'SP',
	},
	SPVoucherFeeBatchesRevokedCount: {
		defaultValue: 'Revoked',
		description: 'Label for the revoked count input field.',
		displayPath: `${dpRoot}|Revoked Count`,
		displayType: 'Label',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'SP',
	},
	SPVoucherFeeBatchesTotalCount: {
		defaultValue: 'Voucher Count',
		description: 'Label for the total count input field.',
		displayPath: `${dpRoot}|Total Count`,
		displayType: 'Label',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'SP',
	},
	SPVoucherFeeBatchesVoucherId: {
		defaultValue: 'Voucher ID',
		description: 'Label for the voucher ID input field.',
		displayPath: `${dpRoot}|Voucher ID`,
		displayType: 'Label',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'SP',
	},
	SPVoucherFeeBatchesRedeemedBy: {
		defaultValue: 'Redeemed By',
		description: 'Label for the redeemed by input field.',
		displayPath: `${dpRoot}|Redeemed By`,
		displayType: 'Label',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'SP',
	},
	SPVoucherFeeBatchesRedeemedDate: {
		defaultValue: 'Redeemed Date',
		description: 'Label for the redeemed date input field.',
		displayPath: `${dpRoot}|Redeemed Date`,
		displayType: 'Label',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'SP',
	},
	SPVoucherFeeBatchesStatus: {
		defaultValue: 'Status',
		description: 'Label for the status input field.',
		displayPath: `${dpRoot}|Status`,
		displayType: 'Label',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'SP',
	},
	SPVoucherFeeBatchesChangeExpirationTitle: {
		defaultValue: 'Change Expiration',
		description: 'Title for the change expiration modal.',
		displayPath: `${dpRoot}|Change Expiration Title`,
		displayType: 'Title',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'SP',
	},
	SPVoucherFeeBatchesChangeExpirationCancelButton: {
		defaultValue: 'Cancel',
		description: 'Button text to cancel the change expiration process.',
		displayPath: `${dpRoot}|Change Expiration Cancel Button`,
		displayType: 'Button',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'SP',
	},
	SPVoucherFeeBatchesTokenSearchButton: {
		defaultValue: 'Search Token',
		description: 'Button to search for a single token.',
		displayPath: `${dpRoot}|Search Token`,
		displayType: 'Button',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'SP',
	},
	SPVoucherFeeBatchesChangeExpirationButton: {
		defaultValue: 'Change Expiration',
		description: 'Button to change the expiration date of voucher batches.',
		displayPath: `${dpRoot}|Change Expiration`,
		displayType: 'Button',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'SP',
	},
	SPVoucherFeeBatchesChangeExpirationErrorExpirationDateRequired: {
		defaultValue: 'Expiration date is required.',
		description: 'Error message for the expiration date input field.',
		displayPath: `${dpRoot}|Change Expiration Error Expiration Date Required`,
		displayType: 'Error',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'SP',
	},
	SPVoucherFeeBatchesChangeExpirationConfirmButton: {
		defaultValue: 'Change Expiration',
		description: 'Button text to confirm the change expiration process.',
		displayPath: `${dpRoot}|Change Expiration Confirm Button`,
		displayType: 'Button',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'SP',
	},
	SPVoucherFeeBatchesInvalidateButton: {
		defaultValue: 'Invalidate',
		description: 'Button to invalidate voucher batches.',
		displayPath: `${dpRoot}|Invalidate`,
		displayType: 'Button',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'SP',
	},
	SPVoucherFeeBatchesDownloadButton: {
		defaultValue: 'Download',
		description: 'Button to download voucher batches.',
		displayPath: `${dpRoot}|Download`,
		displayType: 'Button',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'SP',
	},
	SPVoucherFeeBatchesChangeExpirationLabelRemoveExpirationDate: {
		defaultValue: 'Remove Expiration Date',
		description: 'Label for the remove expiration date checkbox.',
		displayPath: `${dpRoot}|Remove Expiration Date`,
		displayType: 'Label',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'SP',
	},
	SPVoucherFeeBatchesChangeExpirationLabelExpirationDate: {
		defaultValue: 'Expiration Date',
		description: 'Label for the expiration date input field.',
		displayPath: `${dpRoot}|Expiration Date`,
		displayType: 'Label',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'SP',
	},
	SPVoucherFeeBatchesChangeExpirationSuccess: {
		defaultValue: 'Expiration date changed successfully.',
		description: 'Success message when changing the expiration date of voucher batches.',
		displayPath: `${dpRoot}|Change Expiration Success`,
		displayType: 'Notification',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'SP',
	},
	SPVoucherFeeBatchesChangeExpirationError: {
		defaultValue: 'Error changing the expiration date of voucher batches.',
		description: 'Error message when changing the expiration date of voucher batches.',
		displayPath: `${dpRoot}|Change Expiration Error`,
		displayType: 'Error',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'SP',
	},
	SPVoucherFeeBatchesInvalidateSuccess: {
		defaultValue: 'Voucher batches invalidated successfully.',
		description: 'Success message when invalidating voucher batches.',
		displayPath: `${dpRoot}|Invalidate Success`,
		displayType: 'Notification',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'SP',
	},
	SPVoucherFeeBatchesInvalidateError: {
		defaultValue: 'Error invalidating voucher batches.',
		description: 'Error message when invalidating voucher batches.',
		displayPath: `${dpRoot}|Invalidate Error`,
		displayType: 'Error',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'SP',
	},
	SPVoucherFeeBatchesInvalidateTitle: {
		defaultValue: 'Invalidate Voucher Batches',
		description: 'Title for the invalidate voucher batches modal.',
		displayPath: `${dpRoot}|Invalidate Title`,
		displayType: 'Title',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'SP',
	},
	SPVoucherFeeBatchesInvalidateDescription: {
		defaultValue: 'Are you sure you want to invalidate the selected voucher batches?',
		description: 'Description for the invalidate voucher batches modal.',
		displayPath: `${dpRoot}|Invalidate Confirmation Description`,
		displayType: 'Content',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: true,
		shared: false,
		portal: 'SP',
	},
	SPVoucherFeeBatchesInvalidateConfirmButton: {
		defaultValue: 'Invalidate',
		description: 'Button text to confirm the invalidate voucher batches process.',
		displayPath: `${dpRoot}|Invalidate Confirm Button`,
		displayType: 'Button',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'SP',
	},
	SPVoucherFeeBatchesInvalidateCancelButton: {
		defaultValue: 'Cancel',
		description: 'Button text to cancel the invalidate voucher batches process.',
		displayPath: `${dpRoot}|Invalidate Cancel Button`,
		displayType: 'Button',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'SP',
	},
	'0832f1f53d1f49aa8e6b8aa2caebf79e': {
		defaultValue: 'Vouchers already exist.',
		description: 'Error message for when vouchers already exist.',
		displayPath: `${dpRoot}|Vouchers Exist`,
		displayType: 'Error',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'SP',
	},
	'8e8b43e31a424c1685b514d14de96241': {
		defaultValue: 'No valid vouchers found',
		description: 'Error message for when no valid vouchers are found.',
		displayPath: `${dpRoot}|No Valid Vouchers`,
		displayType: 'Error',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'SP',
	},
	b21d04e578464148994c8398a0d20302: {
		defaultValue: 'Batch already exists',
		description: 'Error message for when a batch already exists.',
		displayPath: `${dpRoot}|Batch Exists`,
		displayType: 'Error',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'SP',
	},
	'39d9015e45bb46a79d83701f82fafac7': {
		defaultValue: 'Vouchers with invalid types',
		description: 'Error message for vouchers with invalid types.',
		displayPath: `${dpRoot}|Invalid Voucher Types`,
		displayType: 'Error',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'SP',
	},
	d58dabc2009e4105964ded449795dc42: {
		defaultValue: 'One or more vouchers already exist',
		description: 'Error message for when one or more vouchers already exist.',
		displayPath: `${dpRoot}|One Or More Vouchers Exist`,
		displayType: 'Error',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'SP',
	},
	'6ea279e24b644540a1c9042adc5f03f7': {
		defaultValue: 'Failed to insert vouchers',
		description: 'Error message for when voucher insertion fails.',
		displayPath: `${dpRoot}|Failed To Insert Vouchers`,
		displayType: 'Error',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'SP',
	},
};

export const spVoucherFeeBatchesLocs = MapLocKeys<SPVoucherFeeBatchesLocs>(
	spVoucherFeeBatchesLocDefs
);

export type SPVoucherFeeBatchesLocKeys = typeof spVoucherFeeBatchesLocs;
